module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/student-gray-5a46bf614e4192e9bd2b1e58bc61f947.svg";